import Layout from "../../components/Layout";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from 'react';
import axios from 'axios';
import BattleResultArea from "../../components/battleResultArea/BattleResultArea";
import { useBattleTeam } from "../../context/battleTeam/useBattleTeam";
import { BattleResultLineType } from "../../components/battleResultArea/BattleResultLine";
import { Typography } from "@material-ui/core";
import { modalStressTextColor } from "../../components/lib/Color";
import { MemberType } from "../../components/Type/TeamType";
import { EffectSkilePositionType } from "../../components/assetSettingModal/hooks/AssetSettingModalType";

// import { EffectSkilePositionType, OpenProps } from "../assetSettingModal/hooks/AssetSettingModalType";

const BattleResult: React.FC = () => {
    let history = useHistory();
    const { attack, defence } = useBattleTeam()
    const [battleResultLines, setBattleResultLines] = useState<BattleResultLineType[]>([]);
    const [victory, setVictory] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        console.log(attack)
        console.log(defence)
    }, [attack, defence]);
    const pageBack = () => history.push("/")

    const getMemberAssetId = (member?: MemberType, effectSkilePosition?: EffectSkilePositionType) => {
        switch (effectSkilePosition) {
            case "ExtensionRight":
                return member?.rightExtension?.id
            case "ExtensionLeft":
                return member?.leftExtension?.id
            case "ArtSkill":
                return member?.artSkill?.id
        }
    }

    useEffect(() => {
        console.log(attack)
        console.log(defence)
        const requestData = {
            pl_h1: attack?.front.hero?.id,
            pl_h1_act1: getMemberAssetId(attack?.front, attack?.front.effectSkilePositionTop),
            pl_h1_act2: getMemberAssetId(attack?.front, attack?.front.effectSkilePositionCenter),
            pl_h1_act3: getMemberAssetId(attack?.front, attack?.front.effectSkilePositionBottom),
            pl_h2: attack?.middle.hero?.id,
            pl_h2_act1: getMemberAssetId(attack?.middle, attack?.middle.effectSkilePositionTop),
            pl_h2_act2: getMemberAssetId(attack?.middle, attack?.middle.effectSkilePositionCenter),
            pl_h2_act3: getMemberAssetId(attack?.middle, attack?.middle.effectSkilePositionBottom),
            pl_h3: attack?.back.hero?.id,
            pl_h3_act1: getMemberAssetId(attack?.back, attack?.back.effectSkilePositionTop),
            pl_h3_act2: getMemberAssetId(attack?.back, attack?.back.effectSkilePositionCenter),
            pl_h3_act3: getMemberAssetId(attack?.back, attack?.back.effectSkilePositionBottom),
            en_h1: defence?.front.hero?.id,
            en_h1_act1: getMemberAssetId(defence?.front, defence?.front.effectSkilePositionTop),
            en_h1_act2: getMemberAssetId(defence?.front, defence?.front.effectSkilePositionCenter),
            en_h1_act3: getMemberAssetId(defence?.front, defence?.front.effectSkilePositionBottom),
            en_h2: defence?.middle.hero?.id,
            en_h2_act1: getMemberAssetId(defence?.middle, defence?.middle.effectSkilePositionTop),
            en_h2_act2: getMemberAssetId(defence?.middle, defence?.middle.effectSkilePositionCenter),
            en_h2_act3: getMemberAssetId(defence?.middle, defence?.middle.effectSkilePositionBottom),
            en_h3: defence?.back.hero?.id,
            en_h3_act1: getMemberAssetId(defence?.back, defence?.back.effectSkilePositionTop),
            en_h3_act2: getMemberAssetId(defence?.back, defence?.back.effectSkilePositionCenter),
            en_h3_act3: getMemberAssetId(defence?.back, defence?.back.effectSkilePositionBottom),
        }
        axios.post("https://mch-dragon-simulator.herokuapp.com/api/battle/", requestData).then(res => {
            // TODO 要調査
            const data: any = res?.data
            console.log(res)
            setVictory(data.victory)

            setVictory(data.victory)
            setBattleResultLines(Object.values(data.results))
            setIsLoading(false);
        }).catch(error => {
            console.log(error);
            alert("エラーが、発生しました　画面のスクリーンショットを撮ってコミニュティで共有お願いします！")
            setError(true)
        })
    }, []);

    useEffect(() => {
        error && pageBack()
    }, [error])

    return (
        <Layout>
            {attack && defence && !isLoading ? <BattleResultArea onBackButtonClick={pageBack} attack={attack} defence={defence} victory={victory} battleResultLines={battleResultLines} /> : <>
                <Typography variant={"h1"} style={{ color: modalStressTextColor, margin: "10" }}>バトル準備中です！</Typography>
            </>}
        </Layout >
    );
};

export default BattleResult;
